import { ResolvedPos } from 'prosemirror-model'
import { Match } from './Types'

export const matcher = ($pos: ResolvedPos): Match | undefined => {
  const regexp = new RegExp(/:[^\s:]*/, 'g')
  const text = $pos.doc.textBetween($pos.before(), $pos.pos, '\0', '\0')

  let match

  while ((match = regexp.exec(text))) {
    const prefix = match.input.slice(Math.max(0, match.index - 1), match.index)
    if (!/^[\s\0]?$/.test(prefix)) {
      continue
    }

    const from = $pos.start() + match.index
    const to = from + match[0].length
    if (from < $pos.pos && to >= $pos.pos && to - from > 1) {
      return { range: { from, to }, text: match[0] }
    }
  }
}
